var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-background',{staticStyle:{"height":"100vh"},attrs:{"src":_vm.backgroundVideo,"poster":_vm.poster}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }